import TextBox from "../../../../components/textfield/textbox";
import HeaderBar from "../../../../components/header/headerBar";
import "../../../../assets/styles/admin/usergroup.scss";
import Icon from "@mdi/react";
import { mdiPlus, mdiMinusCircle, mdiPlusCircle, mdiMinus } from "@mdi/js";
import MainButton from "../../../../components/button/mainButton";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import {
  Form,
  Modal,
  Row,
  Col,
  Button,
  Space,
  Pagination,
  Checkbox,
} from "antd";
import axios from "axios";
import { useParams } from "react-router-dom";
import "../../../../assets/styles/admin/personnel.scss";

const UsersGroupsSetting = () => {
  interface ParamTypes {
    id: string;
  }
  const { id } = useParams<ParamTypes>();

  const history = useHistory();
  const [actionsData, setActionsData] = useState<any>([]);
  const [group, setGroup] = useState<any>([]);
  const [state, setState] = useState<any>({
    usdata: [],
    data: [],
  });

  const usdata = [
    {
      name: "DASHBOARD & REPORT",
    },
    {
      name: "OPD",
    },
    {
      name: "CASHIER",
    },
    {
      name: "USED COURSE",
    },
    {
      name: "JOB COST",
    },
    {
      name: "BOOKING",
    },
    {
      name: "COURSE",
    },
    {
      name: "PROMOTION",
    },
    {
      name: "GIFT VOUCHER",
    },
    {
      name: "STOCK",
    },
  ];
  const data = [
    {
      name: "QUOTATION",
    },
    {
      name: "PERSONNEL",
    },
    {
      name: "JOB TITLE",
    },
    {
      name: "Agency",
    },
    {
      name: "Branches",
    },
  ];

  const getAPIs = () => {
    setState({ ...state, usdata: usdata, data: data });
  };

  const addItem = (item: any, index: number) => {
    let myRemoveItems = [...state.usdata];
    let myPushItems = [...state.data];

    if (item.name) {
      myRemoveItems.push(item);
      myPushItems.splice(index, 1);
      setState({ ...state, data: myPushItems, usdata: myRemoveItems });
    }
  };

  const removeItem = (item: any, index: number): void => {
    let myRemoveItems = [...state.usdata];
    let myPushItems = [...state.data];

    if (item.name) {
      myPushItems.push(item);
      myRemoveItems.splice(index, 1);
      setState({ ...state, data: myPushItems, usdata: myRemoveItems });
    }
  };

  const addAllItem = () => {
    let myRemoveItems = [...state.usdata];
    let myPushItems = [...state.data];

    let myArray = myRemoveItems.concat(myPushItems);

    myPushItems = [];
    setState({ ...state, data: myPushItems, usdata: myArray });
  };

  const removeAllItem = () => {
    let myRemoveItems = [...state.usdata];
    let myPushItems = [...state.data];

    let myArray = myRemoveItems.concat(myPushItems);

    myRemoveItems = [];

    setState({ ...state, data: myArray, usdata: myRemoveItems });
  };

  const getData = async () => {
    await axios.get(`/permissions/get-permissions/show/${id}`).then((res) => {
      setGroup(res.data);
    });
  };

  const getActionsData = async () => {
    await axios.get(`/permissions/get-actions`).then((res) => {
      console.log("res.data =>", res.data);
      // setActionsData(res.data);
    });
  };

  useEffect(() => {
    // getAPIs();
    getData();
    getActionsData();
  }, []);

  return (
    <div>
      <HeaderBar title="USERS GROUPS / SETTING" btnBack />
      <div style={{ padding: "10px 40px" }} className="license-list">
        <div className="create-page" style={{ padding: "20px 80px" }}>
          <div className="row">
            <TextBox
              className="col-4"
              title="กลุ่มผู้ใช้งาน/User Group"
              value={group.name}
            />
          </div>
        </div>
        <div style={{ marginTop: "50px" }}>
          <div className="container">
            <div className="row justify-content-center card">
              <div className="col-12 bg-hex">
                <div className="col-10 text-colunm">
                  รายการสิทธิ์การใช้งาน/License List
                </div>
                <div
                  className="col-2 text-colunm pd-8"
                  style={{ textAlign: "end" }}
                >
                  Select All
                  <Checkbox
                  // className="bg-minus"
                  // onClick={() => {
                  //   removeAllItem();
                  // }}
                  ></Checkbox>
                </div>
              </div>
              <div className="col-6 border bg-hex">
                <div className="col-10 text-colunm">รายการสิทธิ์การใช้งาน</div>
                <div className="col-4 text-colunm pd-8">
                  เลือกทั้งหมด
                  <div
                    className="bg-plus"
                    onClick={() => {
                      addAllItem();
                    }}
                  >
                    <Icon path={mdiPlus} size="24" color="#FFFFFF" />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="card col-6">
                <div className="card-body">
                  {state.usdata.map((item: any, index: number) => (
                    <div className="row">
                      <div className="border p-2 m-2 rounded">
                        <div className="text-value">
                          <div className="font-size-text">{item.name}</div>
                          <div
                            className="font-text-value"
                            onClick={() => {
                              removeItem(item, index);
                            }}
                          >
                            <Icon
                              path={mdiMinusCircle}
                              size="24"
                              color="#E76464"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="card col-6">
                <div className="card-body">
                  {state.data.map((item: any, index: number) => (
                    <div className="row">
                      <div className="border p-2 m-2 rounded">
                        <div className="text-value">
                          <div className="font-size-text">{item.name}</div>
                          <div
                            className="font-text-value"
                            onClick={() => {
                              addItem(item, index);
                            }}
                          >
                            <Icon
                              path={mdiPlusCircle}
                              size="24"
                              color="#4D7E7F"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="justify-center mt-20">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก/Cancel"
                onClick={() => history.push(`/setting/usersgroups`)}
              />
              <MainButton className="mg-10" title="บันทึกข้อมูล/Submit" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UsersGroupsSetting;
